import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/axios.js'
import router from '@/router'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    news: [],
    wallets: [],
    financeDetails: [],
    listTransactions: [],
    bitcoins: {},
    dataSaldo: []
  },
  mutations: {
    fetchNews(state, payload) {
      state.news = payload
    },
    fetchWallets(state, payload) {
      state.wallets = payload
    },
    financeDetails(state, payload) {
      state.financeDetails = payload
    },
    bitcoins(state, payload) {
      state.bitcoins = payload
    },
    listTransactions(state, payload) {
      state.listTransactions = payload
    },
    setLogin(state, val) {
      state.isLogin = val
    },
    dataSaldo(state, payload) {
      state.dataSaldo = payload
    }
  },
  actions: {
    signin(context, payload) {
      axios.post('/signin', payload)
        .then(({ data }) => {
          localStorage.setItem('access_token', data.access_token)
          context.commit('setLogin', true)
          router.push({ name: 'Home' })
        })
        .catch(error => {
          console.log(error)
          console.log('error di signin')
        })
    },
    logout(context) {
      localStorage.clear()
      context.commit('setLogin', false)
      router.push({ name: 'Signin' })
    },
    fetchNews(context) {
      axios.get('/news')
        .then(({ data }) => {
          console.log(data, 'ini dari data news')
          context.commit('fetchNews', data)
        })
        .catch(error => {
          console.log(error, 'error dari news')
        })
    },
    fetchWallets(context) {
      axios.get('/finances', {
        headers: {
          access_token: localStorage.access_token
        }
      })
        .then(({ data }) => {
          console.log(data, 'ini dari wallet')
          context.commit('fetchWallets', data)
        })
        .catch(error => {
          console.log(error, 'error dari wallet')
        })
    },
    addNewWallet(context, payload) {
      axios.post('/finances', payload, {
        headers: {
          access_token: localStorage.access_token
        }
      })
        .then(({ data }) => {
          console.log(data, 'ini dari add new wallet')
          this.dispatch('fetchWallets')
        })
        .catch(error => {
          console.log(error, 'error dari add new wallet')
        })
    },
    financeDetails(context, id) {
      axios.get(`/finances/${id}`, {
        headers: {
          access_token: localStorage.access_token
        }
      })
        .then(({ data }) => {
          console.log(data, 'ini dari finances')
          context.commit('financeDetails', data)
          router.push({ name: 'FinanceDetails', params: { id } })
          console.log(data, 'udh push')
        })
        .catch(error => {
          console.log(error, 'error dari financeDetails')
        })
    },
    bitcoins(context) {
      axios.get('/bitcoins')
        .then(({ data }) => {
          console.log(data, 'ini dari bitcoins')
          context.commit('bitcoins', data)
        })
        .catch(error => {
          console.log(error, 'error dari bitcoins')
        })
    },
    deleteTransactions(context, payload) {
      axios.delete(`/finances/${payload.id}`, {
        headers: {
          access_token: localStorage.access_token
        }
      })
        .then(({ data }) => {
          console.log(data, 'ini dari delete transactions')
          if (payload.name) {
            router.push({ name: 'Wallet' })
          } else {
            this.dispatch('financeDetails', payload.financeId)
          }
        })
        .catch(error => {
          console.log(error, 'error dari transactions')
        })
    },
    listTransactions(context) {
      axios.get('/finances/all', {
        headers: {
          access_token: localStorage.access_token
        }
      })
        .then(({ data }) => {
          console.log(data, 'ini dari list transactions')
          context.commit('listTransactions', data)
        })
        .catch(error => {
          console.log(error, 'error dari list transactions')
        })
    },
    addNewTransactions(context, payload) {
      axios.post(`/finances/${payload.financeId}`, payload, {
        headers: {
          access_token: localStorage.access_token
        }
      })
        .then(({ data }) => {
          console.log(data, 'ini dari add new Transactions')
          this.dispatch('listTransactions')
        })
        .catch(error => {
          console.log(error, 'error dari add new Transactions')
        })
    },
    setLogin (context, val) {
      context.commit('setLogin', val)
    },
    signup (context, payload) {
      axios.post('/signup', payload)
        .then(() => {
          router.push({ name: 'Signin' })
        })
        .catch(error => {
          console.log(error)
        })
    },
    dataSaldo (context) {
      axios.get('/finances/saldo', {
        headers: {
          access_token: localStorage.access_token
        }
      })
        .then(({data}) => {
          context.commit('dataSaldo', data)
        })
        .catch(error => {
          console.log(error, 'ini dari error saldo')
        })
    }
  }
})
